/* eslint-disable no-unsafe-optional-chaining */
import { Injectable } from '@angular/core';

import { Template } from '@site-mate/dashpivot-shared-library';

import { Tab } from 'app/shared/model/template-tab.model';

export interface IGroupedTemplate {
  tab: Tab;
  templates: Template[];
}

@Injectable({
  providedIn: 'root',
})
export class TemplatesTabsService {
  private untaggedValue = 'untagged';
  private untaggedTab = {
    value: this.untaggedValue,
    name: 'Untagged',
    style: 'shale',
  };

  groupTemplatesByTabAndSort(templates: Template[], tabs: Tab[]): Map<string, IGroupedTemplate> {
    return this.sortGroupedTemplates(this.groupTemplatesByTab(templates), tabs);
  }

  private groupTemplatesByTab(templates: Template[]): Map<string, IGroupedTemplate> {
    return templates.reduce((groupedTemplates, template) => {
      let tabs = template.templateTags || [];
      tabs = tabs.length > 0 ? tabs : [this.untaggedTab];

      return this.groupTemplates({ groupedTemplates, tabs, template });
    }, new Map());
  }

  private groupTemplates({ groupedTemplates, tabs, template }): Map<string, IGroupedTemplate> {
    return tabs.reduce((group, tab) => {
      const { value } = tab;

      if (!group.has(value)) {
        group.set(value, { tab, templates: [] });
      }

      group.get(value).templates.push(template);

      return group;
    }, groupedTemplates);
  }

  private sortGroupedTemplates(templateGroupedByTabs, tabs): Map<string, IGroupedTemplate> {
    const mappedTabsWithSortValue = this.mapTabsWithSortValue(tabs);

    return new Map(
      [...templateGroupedByTabs].sort(([firstValue], [secondValue]) => {
        if (this.untaggedValue === firstValue) {
          return 1;
        }

        if (this.untaggedValue === secondValue) {
          return -1;
        }

        const { tab: firstTab, tabIndex: firstTabIndex } = mappedTabsWithSortValue?.get(firstValue);
        const { tab: secondTab, tabIndex: secondTabIndex } = mappedTabsWithSortValue?.get(secondValue);

        const firstSortValue = firstTab && firstTab.sortValue;
        const secondSortValue = secondTab && secondTab.sortValue;

        if (firstSortValue === secondSortValue) {
          return firstTabIndex - secondTabIndex;
        }

        if (secondSortValue === undefined) {
          return -1;
        }

        return firstSortValue - secondSortValue;
      }),
    );
  }

  private mapTabsWithSortValue(tabs: Tab[]): Map<string, { tab: Tab; tabIndex: number }> {
    return tabs.reduce((mappedTabs, tab, tabIndex) => {
      mappedTabs.set(tab.id, { tab, tabIndex });

      return mappedTabs;
    }, new Map());
  }
}
